<script lang="ts">
      import BlockWidth from '../blocks/BlockWidth.svelte'
      import CategoryTitle from '../feed/CategoryTitle.svelte'
      import BlockHeading from '../ui/BlockHeading.svelte'
      import Logo from './Logo.svelte'

      let { block } = $props()

</script>

<BlockWidth width={block.width ?? "wide"}>
      {#if block}
            <div class="w-full mx-auto p-2">
                  <BlockHeading>{block.title}</BlockHeading>
                  <div class="w-full grid grid-template items-center justify-between">
                        {#each block.logos as item, i (i)}
                              <Logo {item}></Logo>
                        {/each}
                  </div>
            </div>
      {/if}
</BlockWidth>

<style lang="postcss">
      .grid-template {
        grid-template-columns: repeat(auto-fill, minmax(8rem, 1fr));
        @screen md {
          grid-template-columns: repeat(auto-fill, minmax(10rem, 1fr));
        }
        @screen lg {
          grid-template-columns: repeat(auto-fill, minmax(13rem, 10%));
        }
        /*grid-template-columns: repeat(auto-fill, minmax(10%, 50%));
            @screen md {
                  grid-template-columns: repeat(auto-fill, minmax(10%, 33%));
            }

            @screen xl {
                  grid-template-columns: repeat(auto-fill, minmax(10%, 20%));
            }*/
            /*grid-template-rows: repeat(auto-fill, minmax(16rem, 1fr));*/
      }
</style>
